

interface SchemaStyled {
  color: string;
  title: string;
  description?: string;
}

interface SelectedSchemaProps {
  [key: string]: SchemaStyled;
}

const root_interview = (key: string) => `private-home-page:actions.${key}`;

const root_offer = (key: string) => `private-home-page:jobOffer.${key}`;

export const selectedSchema: SelectedSchemaProps = {
  // Interview Status
  interview: {
    color: "#2D9BF0",
    title: root_interview("interview"),
  },
  hired: {
    color: "#2AA789",
    title: root_interview("hired"),
  },
  not_approved: {
    color: "#DA0163",
    title: root_interview("not_approved"),
  },
  deny_job_offer: {
    color: "#F24725",
    title: root_interview("deny_job_offer"),
  },
  not_interviewed: {
    color: "#EDB4CD",
    title: root_interview("not_interviewed"),
  },
  not_suitable: {
    color: "#EDB4CD",
    title: root_interview("not_suitable"),
  },
  // Offer Status
  pending: {
    color: "#C9C9C9",
    title: root_offer("status.pending"),
    description: root_offer("description.pending"),
  },
  match: {
    color: "#2AA789",
    title: root_offer("status.match"),
    description: root_offer("description.match"),
  },
  rejected: {
    color: "#F24725",
    title: root_offer("status.rejected"),
    description: root_offer("description.notInterested"),
  },
};
